
import enLocale from "i18n-nationality/langs/en.json";
import frLocale from "i18n-nationality/langs/fr.json";
import nationality from 'i18n-nationality';
import { useTranslationLang } from "@bsm/component";

nationality.registerLocale(enLocale);
nationality.registerLocale(frLocale);


export const formatNationnality = (codes: string | null | undefined): string => {
  if (!codes) return '-';

  const nationalityNamesEn = nationality.getNames("en");
  const nationalityNamesFr = nationality.getNames("fr");

  const { lang } = useTranslationLang();
  const nationalities = lang === 'fr' ? nationalityNamesFr : nationalityNamesEn;


  return codes.split(',').map(code => nationalities[code.trim()] || code.trim()).join(', ');
};
